import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { SegmentsState } from 'types/segments/segments.types';

// Base selector
const selectSegmentsState = (state: RootState): SegmentsState => state.segments;

// Memoized selectors
export const selectSegments = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.segments
);

export const selectSelectedSegment = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.selectedSegment
);

export const selectSegmentsLoading = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.loading
);

export const selectSegmentsError = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.error
);

export const selectSegmentsPagination = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.pagination
);

// Derived selectors
export const selectSegmentById = (id: string) =>
  createSelector([selectSegments], (segments) =>
    segments.find((segment) => segment._id === id)
  );

export const selectSegmentsTotal = createSelector(
  [selectSegmentsPagination],
  (pagination) => pagination.total
);

export const selectSegmentsCurrentPage = createSelector(
  [selectSegmentsPagination],
  (pagination) => pagination.page
);

export const selectSegmentsTotalPages = createSelector(
  [selectSegmentsPagination],
  (pagination) => pagination.totalPages
);

export const selectSegmentsSuccess = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.success
);

export const selectContacts = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.contacts
);

export const selectContactsLoading = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.contactsLoading
);

export const selectContactsError = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.contactsError
);

export const selectContactsPagination = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.contactsPagination
);

export const selectSegmentsExportBlob = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.exportBlob
);

export const selectSegmentsExportBlobLoading = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.exportBlobLoading
);

export const selectRemoveContactLoading = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.removeContactLoading
);

export const selectRemoveContactError = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.removeContactError
);

export const selectRemoveContactSuccess = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.removeContactSuccess
);

export const selectAddContactsToSegmentLoading = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.addContactsToSegmentLoading
);

export const selectAddContactsToSegmentError = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.addContactsToSegmentError
);

export const selectAddContactsToSegmentSuccess = createSelector(
  [selectSegmentsState],
  (segmentsState) => segmentsState.addContactsToSegmentSuccess
);
